import usePlacesAutocomplete, {
  getGeocode,
  getLatLng,
} from "use-places-autocomplete";

const PlacesAutocomplete = ({ onSelect }) => {
  const {
    ready,
    value,
    suggestions: { status, data },
    setValue,
    clearSuggestions,
  } = usePlacesAutocomplete({
    debounce: 300,
  });

  const handleSelect = async (description) => {
    setValue(description, false);
    clearSuggestions();

    try {
      const results = await getGeocode({ address: description });
      const { lat, lng } = await getLatLng(results[0]);
      onSelect({ address: description, lat, lng });
    } catch (error) {
      console.error("Error al obtener la ubicación:", error);
    }
  };

  return (
    <div>
      <input
        value={value}
        onChange={(e) => setValue(e.target.value)}
        placeholder="Escribe una dirección"
        disabled={!ready}
        className="form-input"
      />
      {status === "OK" &&
        data.map(({ place_id, description }) => (
          <div
            key={place_id}
            onClick={() => handleSelect(description)}
            className="suggestion-item"
          >
            {description}
          </div>
        ))}
    </div>
  );
};

export default PlacesAutocomplete;
